var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("\n    "+_vm._s(_vm._f("explanation")(_vm.text))+"\n  ")]),_c('p',[_vm._v("\n    Please follow up with the provider and encourage them to update their contact details in HITS. \n    Once they have done so the updated contacts should appear in LTPS the next day.\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }